import { render, staticRenderFns } from "./Sidelight.vue?vue&type=template&id=0de0ab4d&"
import script from "./Sidelight.vue?vue&type=script&lang=js&"
export * from "./Sidelight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports